/* global axios */

import ApiClient from './ApiClient';

class Agents extends ApiClient {
  constructor() {
    super('agents', { accountScoped: true });
  }

  bulkInvite({ emails }) {
    return axios.post(`${this.url}/bulk_create`, {
      emails,
    });
  }

  sipCredentials(id) {
    return axios.get(`${this.url}/${id}/sip_credentials`);
  }
}

export default new Agents();
